module.exports = __webpack_public_path__ + "img/Banner-HomeModel.05c9326c.jpg";